<!-- Mobile -->
@if (isMobile()) {
<div class="mobile-screen wh-100-background">
  <div class="d-flex flex-row psic-m-2 align-items-center wh-100-background psic-p-6">
    <div class="flex-column">
      @if (popupDisplayObj.imageSrc) {
      <img
        src="{{ popupDisplayObj.imageSrc }}"
        [ngStyle]="{ width: popupDisplayObj.confirm === 'Download' ? '120px' : '48px' }"
        alt="tick-img"
      />
      }
    </div>
    <div class="flex-column" [ngClass]="{ 'psic-ml-2': !popupDisplayObj.download }">
      <h5
        class="intro-quote-text"
        [ngClass]="{ 'text-center psic-p-4': popupDisplayObj.download }"
        style="max-width: 325px"
        [innerHTML]="popupDisplayObj.message"
      ></h5>
      <p
        class="caption psic-pt-1"
        [ngClass]="{ 'text-center': popupDisplayObj.download }"
        [innerHTML]="popupDisplayObj.messageExt"
      ></p>
    </div>
  </div>
  @if (popupDisplayObj.fields && popupDisplayObj.fields.length > 0) {
  <div class="psic-px-6 psic-py-4">
    <form [formGroup]="mobileForm" class="d-flex flex-column psic-gap-3">
      @for (field of popupDisplayObj.fields; track field.id) {
        @if (field.type === 'email') {
          <lib-input-text [formControlName]="field.name" [field]="field" (blur)="verifyEmail()"></lib-input-text>
        } @else if (field.type === 'text' || field.type === 'number') {
          <lib-input-text [formControlName]="field.name" [field]="field"></lib-input-text>
        }
      }
    </form>
  </div>
  }
  <div
    class="d-flex p3-40-background psic-px-6 psic-py-2 justify-content-between align-items-center flex-row"
  >
    @if (popupDisplayObj.cancel) {
    <lib-button
      (callback)="footerButtonAction(popupDisplayObj.cancel)"
      [disabled]="false"
      [buttonTheme]="'tertiary'"
      [buttonType]="'borderless'"
      [buttonSize]="'large'"
      [buttonText]="popupDisplayObj.cancel"
      [libIcon]="'back'"
      [iconLeft]="true"
    >
    </lib-button>
    } @if (popupDisplayObj.confirm) {
    <lib-button
      (callback)="footerButtonAction(popupDisplayObj.confirm)"
      [disabled]="(popupDisplayObj.type == 'actionDialog' && !mobileForm.valid) || (hasEmailField() && !isEmailVerified)"
      [buttonTheme]="'tertiary'"
      [buttonSize]="'large'"
      [buttonText]="popupDisplayObj.confirm"
    ></lib-button>

    }
  </div>
</div>
}
<!-- Desktop and Tablet-->
@else{
<div class="psic-p-9">
  <div class="d-flex flex-column psic-gap-7" style="width: 256px">
    @if (popupDisplayObj.type == 'actionDialog') {
    <div class="d-flex flex-column justify-content-center align-items-center">
      @if (popupDisplayObj.imageSrc) {
      <img
        class="text-center"
        src="{{ popupDisplayObj.imageSrc }}"
        [ngStyle]="{ width: popupDisplayObj.confirm === 'Download' ? '120px' : '64px' }"
        alt="tick-img"
      />
      }
      <div class="d-flex flex-column justify-content-center align-items-center psic-gap-1">
        <h5 class="text-center" [innerHTML]="popupDisplayObj.message"></h5>
        <p class="psic-pt-1 caption text-center" [innerHTML]="popupDisplayObj.messageExt"></p>
      </div>
    </div>
    } @if (popupDisplayObj.fields && popupDisplayObj.fields.length > 0) {
    <form [formGroup]="desktopForm" class="d-flex flex-column psic-gap-3">
      @for (field of popupDisplayObj.fields; track field.id) {
        @if (field.type === 'email') {
          <lib-input-text [formControlName]="field.name" [field]="field" (blur)="verifyEmail()"></lib-input-text>
        } @else if (field.type === 'text' || field.type === 'number') {
          <lib-input-text [formControlName]="field.name" [field]="field"></lib-input-text>
        }
      }
    </form>
    }
    <div class="d-flex flex-row justify-content-center align-items-center psic-gap-10">
      @if (popupDisplayObj.cancel) {
      <lib-button
        (callback)="footerButtonAction(popupDisplayObj.cancel)"
        [disabled]="false"
        [buttonTheme]="'primary'"
        [buttonType]="'borderless'"
        [buttonSize]="'large'"
        [buttonText]="popupDisplayObj.cancel"
        [libIcon]="'back'"
        [iconLeft]="true"
      >
      </lib-button>
      }@if (popupDisplayObj.confirm) {
      <lib-button
        (callback)="footerButtonAction(popupDisplayObj.confirm)"
        [disabled]="(popupDisplayObj.type == 'actionDialog' && !desktopForm.valid) || (hasEmailField() && !isEmailVerified)"
        [buttonSize]="'large'"
        [buttonText]="popupDisplayObj.confirm"
      ></lib-button>
      }
    </div>
  </div>
</div>
}
